"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useItemRef;

var _react = require("react");

var _useContext2 = _interopRequireDefault(require("./private/useContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useItemRef(itemIndex) {
  var ref = (0, _react.useRef)();

  var _useContext = (0, _useContext2.default)(),
      itemEffector = _useContext.itemEffector;

  (0, _react.useEffect)(function () {
    itemEffector(ref, itemIndex);
  });
  return ref;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VJdGVtUmVmIiwiaXRlbUluZGV4IiwicmVmIiwidXNlUmVmIiwidXNlQ29udGV4dCIsIml0ZW1FZmZlY3RvciIsInVzZUVmZmVjdCJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3Byb3ZpZGVycy9Sb3ZpbmdUYWJJbmRleC91c2VJdGVtUmVmLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IHVzZUVmZmVjdCwgdXNlUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHVzZUNvbnRleHQgZnJvbSAnLi9wcml2YXRlL3VzZUNvbnRleHQnO1xuXG5pbXBvcnQgdHlwZSB7IE11dGFibGVSZWZPYmplY3QgfSBmcm9tICdyZWFjdCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZUl0ZW1SZWY8VCBleHRlbmRzIEhUTUxFbGVtZW50PihpdGVtSW5kZXg6IG51bWJlcik6IE11dGFibGVSZWZPYmplY3Q8VCB8IHVuZGVmaW5lZD4ge1xuICBjb25zdCByZWYgPSB1c2VSZWY8VD4oKTtcblxuICBjb25zdCB7IGl0ZW1FZmZlY3RvciB9ID0gdXNlQ29udGV4dCgpO1xuXG4gIHVzZUVmZmVjdCgoKSA9PiB7XG4gICAgaXRlbUVmZmVjdG9yKHJlZiwgaXRlbUluZGV4KTtcbiAgfSk7XG5cbiAgcmV0dXJuIHJlZjtcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOztBQUNBOzs7O0FBSWUsU0FBU0EsVUFBVCxDQUEyQ0MsU0FBM0MsRUFBK0Y7RUFDNUcsSUFBTUMsR0FBRyxHQUFHLElBQUFDLGFBQUEsR0FBWjs7RUFFQSxrQkFBeUIsSUFBQUMsb0JBQUEsR0FBekI7RUFBQSxJQUFRQyxZQUFSLGVBQVFBLFlBQVI7O0VBRUEsSUFBQUMsZ0JBQUEsRUFBVSxZQUFNO0lBQ2RELFlBQVksQ0FBQ0gsR0FBRCxFQUFNRCxTQUFOLENBQVo7RUFDRCxDQUZEO0VBSUEsT0FBT0MsR0FBUDtBQUNEIn0=